module.exports = __webpack_public_path__ + "img/prioritas_vippack_cod_k.6ec78c01.png";